module.exports = __webpack_public_path__ + "img/1-12.97d991f3.png";